import {Box} from '@primer/react'
import {colorNames, useNamedColor} from '@github-ui/use-named-color'
import type {IssueTypeColor} from './__generated__/IssueTypePickerIssueType.graphql'

import styles from './IssueTypePickerItemLeadingVisual.module.css'

export const createIssueTypePickerItemLeadingVisual = (color: IssueTypeColor) =>
  function IssueTypePickerItemLeadingVisual() {
    const effectiveColor = colorNames.find(c => c === color)
    const {bg, accent} = useNamedColor(effectiveColor)
    return (
      <Box
        sx={{
          bg,
          borderColor: accent,
        }}
        className={styles.issueTypeColorIndicator}
      />
    )
  }

try{ IssueTypePickerItemLeadingVisual.displayName ||= 'IssueTypePickerItemLeadingVisual' } catch {}